import React from 'react';

export const History = ({
  className,
  color,
  height,
  width,
}: {
  className?: string;
  color?: string;
  height?: string;
  width?: string;
}) => (
  <svg
    width={width ?? '27'}
    height={height ?? '27'}
    viewBox="0 0 27 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="icon/action/history_24px">
      <path
        id="icon/action/history_24px_2"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.54395 13.7678C5.54395 8.38366 9.90978 4.01782 15.2939 4.01782C20.6781 4.01782 25.0439 8.38366 25.0439 13.7678C25.0439 19.152 20.6781 23.5178 15.2939 23.5178C12.5964 23.5178 10.1698 22.4237 8.40395 20.6578L9.94228 19.1195C11.3073 20.4953 13.2031 21.3512 15.2939 21.3512C19.4864 21.3512 22.8773 17.9603 22.8773 13.7678C22.8773 9.57532 19.4864 6.18449 15.2939 6.18449C11.1014 6.18449 7.71061 9.57532 7.71061 13.7678H10.9606L6.58395 18.1337L6.50811 17.982L2.29395 13.7678H5.54395ZM14.2104 14.8512V9.43457H15.8354V13.9304L19.6488 16.1946L18.8146 17.5812L14.2104 14.8512Z"
        fill="#6B778C"
      />
    </g>
  </svg>
);
